import React from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Tooltip from '../Tooltip/Tooltip';
var useStyles = makeStyles(function (theme) {
  return {
    font: {
      color: theme.palette.grey[600]
    },
    spaceContainer: {
      paddingLeft: theme.spacing(1.5)
    },
    gridContainer: {
      padding: theme.spacing(0.5, 1.5)
    }
  };
});
var TableFooter = function TableFooter(_ref) {
  var tooltip = _ref.tooltip,
    label = _ref.label,
    logo = _ref.logo,
    link = _ref.link,
    linkLabel = _ref.linkLabel,
    _ref$height = _ref.height,
    height = _ref$height === undefined ? 25 : _ref$height;
  var classes = useStyles();
  return React.createElement(Grid, {
    container: true,
    direction: 'row',
    alignItems: 'center',
    spacing: 2
  }, React.createElement(Grid, {
    item: true,
    xs: 1,
    className: classes.gridContainer
  }, React.createElement(Tooltip, {
    placement: 'top',
    interactive: true,
    title: React.createElement(Typography, {
      variant: 'body2'
    }, React.createElement(Typography, {
      variant: 'inherit'
    }, R.prop('label')(tooltip)), React.createElement('a', {
      className: classes.spaceContainer,
      href: R.prop('link')(tooltip)
    }, R.prop('linkLabel')(tooltip)))
  }, React.createElement(Typography, {
    variant: 'body2',
    className: classes.font
  }, R.ifElse(R.isNil, R.always('©'), R.identity)(label)))), React.createElement(Grid, {
    item: true,
    xs: 11,
    className: classes.gridContainer
  }, React.createElement(Grid, {
    container: true,
    justifyContent: 'flex-end'
  }, React.createElement(Typography, {
    variant: 'body2',
    className: classes.font
  }, React.createElement('a', {
    href: link
  }, linkLabel)), React.createElement('img', {
    className: classes.spaceContainer,
    height: height,
    src: logo,
    alt: 'logo'
  }))));
};
TableFooter.propTypes = process.env.NODE_ENV !== "production" ? {
  tooltip: PropTypes.shape({
    link: PropTypes.string,
    linkLabel: PropTypes.string,
    label: PropTypes.string
  }),
  label: PropTypes.string,
  logo: PropTypes.string,
  link: PropTypes.string,
  linkLabel: PropTypes.string,
  height: PropTypes.number,
  classes: PropTypes.object
} : {};
export default TableFooter;